import styles from './SelectInput.module.scss';
import { ChangeEvent, useRef, type ReactNode } from 'react';
import { InputShared } from './InputShared';

interface Props {
  children: ReactNode;
  defaultValue?: string;
  disabled?: boolean;
  end?: ReactNode;
  extra?: ReactNode;
  grow?: boolean;
  label: string;
  name?: string;
  onChange?: (event: ChangeEvent<HTMLSelectElement>) => void;
  onValue?: (value: string) => void;
  required?: boolean;
  value?: string;
  width?: string;
}

export function SelectInput({
  children,
  defaultValue,
  disabled,
  end,
  label,
  name,
  required,
  value,
  ...props
}: Props) {
  const selectRef = useRef<HTMLSelectElement>(null);

  function onInputClick() {
    if (selectRef.current) {
      selectRef.current.focus();
      selectRef.current.click();
    }
  }

  function onChange(event: ChangeEvent<HTMLSelectElement>) {
    props.onChange?.(event);
    props.onValue?.(event.currentTarget.value);
  }

  return (
    <InputShared end={end} label={label} onClick={onInputClick}>
      {({ id }) => (
        <select
          ref={selectRef}
          className={styles['select-input-element']}
          defaultValue={defaultValue}
          disabled={disabled}
          id={id}
          name={name}
          onChange={onChange}
          required={required}
          value={value}
        >
          {children}
        </select>
      )}
    </InputShared>
  );
}
